export const LOCALE_STORAGE_KEY = "agent-alibi:locale:v1";

export type Locale = "en" | "ru" | "zh";

export type LocaleOption = {
  code: Locale;
  shortLabel: string;
  name: string;
};

export const LOCALES: LocaleOption[] = [
  { code: "en", shortLabel: "EN", name: "English" },
  { code: "ru", shortLabel: "RU", name: "Русский" },
  { code: "zh", shortLabel: "中文", name: "中文" }
];

const en = {
  "language.label": "Language",
  "sound.on": "Sound On",
  "sound.off": "Sound Off",
  "home.eyebrow": "Neon Moon Heist / six rounds / human + AI crew",
  "home.copy": "Pick a plan, watch agents lie through lasers, steal lunar relics, and escape before the vault seals.",
  "home.playNow": "Play Now vs AI",
  "home.createRoom": "Create Room",
  "home.aiDemo": "AI vs AI Demo",
  "home.bestCase": "Best case",
  "home.repeatDenial": "Repeat denial run",
  "home.beatCase": "Beat your case",
  "room.inviteLink": "Invite Link",
  "room.creating": "Creating Room",
  "room.connecting": "Connecting to the heist server...",
  "room.emptySlot": "Empty Slot",
  "room.addAgent": "Add {profileId}",
  "room.startMatch": "Start Match",
  "match.loadingArcade": "Booting Moon Vault...",
  "match.moonVaultRun": "Moon Vault Run",
  "match.timer": "Timer",
  "match.loot": "Loot",
  "match.alarm": "Alarm",
  "match.radar": "Radar",
  "match.radio": "Radio",
  "match.sweepClear": "Sweep clear",
  "match.blueCarrying": "Blue carrying +{loot}",
  "match.blueScore": "Blue {loot}",
  "match.redPending": "AI {loot} (+{pending} pending)",
  "match.redScore": "AI {loot}",
  "match.redRacePending": "Red {loot} (+{pending} pending)",
  "match.redRace": "Red {loot}",
  "match.recoverBeforeRed": "Recover +{pending} before Red banks",
  "match.bankAtLift": "Bank +{cashout} at lift",
  "match.lootRaceTied": "Loot race is tied",
  "match.escape": "Escape",
  "match.cashoutStep": "Cashout +{cashout}",
  "match.breachSprint": "Breach Sprint",
  "match.breachSprintSmall": "{seconds}s launch · follow gold runway",
  "match.ghostSpeedSmall": "{seconds}s speed burst · clean escape",
  "match.extractionLive": "Extraction live",
  "match.cashoutBanked": "Cashout banked +{cashout}",
  "match.untilCaseFile": "{seconds}s until case file",
  "match.runToLift": "Run to lift",
  "match.bankValue": "Bank +{cashout}",
  "match.afterburnerExit": "Afterburner exit +1",
  "match.ghostCleanEscape": "Ghost Step clean escape",
  "match.beforeScans": "{seconds}s before scans · cashout or greed",
  "match.hunterLockOn": "{agentName} lock-on",
  "match.dashBreakLock": "Dash to break lock",
  "match.hunterClosing": "{distance}m closing · {beams} beams live",
  "match.redCashoutImminent": "Red cashout imminent",
  "match.interceptNow": "Intercept now",
  "match.denySwing": "Deny Red +{value} / swing +{swing}",
  "match.agentLiftDistance": "{agentName} is {distance}m from lift · {seconds}s",
  "match.lockBroken": "Lock broken",
  "match.breakoutCashout": "Breakout cashout +{cashout}",
  "match.bankNow": "Bank now",
  "match.lootBreakout": "+{base} loot +{bonus} breakout",
  "match.rookScanJammed": "Rook scan jammed · {seconds}s to bank",
  "match.bonus": "+{bonus} bonus",
  "match.cashoutValue": "Cashout +{cashout}",
  "match.secondsToBank": "{seconds}s to bank",
  "match.scanLock": "Scan lock",
  "match.pressInteract": "Press E / Space",
  "match.jamScan": "Jam scan before alarm burns",
  "match.final30": "Final 30s",
  "match.beforeVaultSeals": "{time} before the vault seals",
  "match.openingContract": "Moon Vault Contract",
  "match.stealMoonPearl": "Steal Moon Pearl +3",
  "match.stealValue": "Steal +{value}",
  "match.stealShort": "Steal +3",
  "match.escapeShort": "Escape",
  "match.alibiShort": "Alibi",
  "match.dashShort": "Dash",
  "match.moonPearlRoute": "Moon Pearl - {route}",
  "match.cashoutAtrium": "Cashout at Atrium Lift",
  "match.pressAtRelic": "Press E / Space at relic",
  "match.optionalRisk": "Optional risk",
  "match.cashoutWindow": "Cashout window",
  "match.primaryTarget": "Primary target",
  "match.liveMissionStatus": "Live mission status",
  "match.vaultStable": "Vault Stable",
  "match.lowProfile": "Low profile",
  "match.miniRadar": "Mini radar",
  "match.scorePopup": "Score popup",
  "match.rivalComms": "Rival comms",
  "match.liveAgents": "Live agents",
  "match.missionRadio": "Mission radio",
  "match.currentObjective": "Current objective",
  "match.activeAction": "Active action",
  "match.objectiveCompass": "Objective compass",
  "match.rivalObjective": "Rival objective",
  "match.missionBeat": "Mission beat",
  "match.heistDirectorCue": "Heist director cue",
  "match.threatVector": "Threat vector",
  "match.contractChain": "Contract chain",
  "match.heistRace": "Heist Race",
  "match.rivalLootAlert": "Rival loot alert",
  "match.rivalIntercept": "Rival intercept",
  "match.carriedLoot": "Carried loot",
  "match.escapePayout": "Escape payout",
  "match.extractionCue": "Extraction cue",
  "match.routeChoice": "Route choice",
  "match.routeDistance": "Route distance",
  "match.rivalCrewStatus": "Rival crew status",
  "match.rivalIntel": "Rival intel",
  "match.nearestRival": "Nearest rival",
  "match.rivalScanMeter": "Rival scan meter",
  "match.runPace": "Run pace",
  "match.momentum": "Momentum",
  "match.rivalCarrying": "{agentName} carrying",
  "match.carryingLoot": "Carrying +{loot}",
  "match.escapeBonus": "Escape bonus +{bonus}",
  "match.cashoutPlain": "Cashout {cashout}",
  "match.greedArmed": "Greed armed",
  "match.greedRoute": "Greed route",
  "match.bankNowValue": "Bank +{cashout} now",
  "match.safeExitLoot": "Safe exit with +{loot} loot",
  "match.riskRelic": "Risk +{value}: {relicName}",
  "match.projectedCashout": "Projected cashout +{cashout} · {distance}m to relic",
  "match.pressGForCashout": "Press G for cashout +{cashout} · {distance}m detour",
  "match.targetPlotting": "Target plotting",
  "match.rivalsScanning": "Rivals scanning",
  "match.nearestRivalScanning": "Nearest rival scanning",
  "match.scanClear": "Scan clear",
  "match.paceUnknown": "Pace unknown",
  "match.secondsLeft": "{seconds}s left",
  "match.momentumMeter": "Momentum meter",
  "match.cleanBonusWindow": "Clean bonus window",
  "match.lootChainWindow": "Loot chain window",
  "match.dashStatus": "Dash status",
  "match.dashCooling": "Dash cooling",
  "match.dashReady": "Dash ready",
  "match.alibiPulseStatus": "Alibi pulse status",
  "match.alibiReady": "Alibi ready",
  "match.optionalRelic": "Optional relic",
  "match.controls": "WASD / arrows move · click to run · Shift dash · E / Space interact · G route",
  "match.move": "Move",
  "match.followMarker": "Follow marker",
  "match.lockdown": "Lockdown",
  "match.alarmRising": "Alarm rising",
  "match.heistLive": "Heist live",
  "match.defaultObjective": "Steal a relic before the vault learns your name",
  "match.target": "Target",
  "match.escapeNow": "Escape now",
  "match.cashoutNow": "Cashout now",
  "match.loadingHeist": "Booting Moon Vault...",
  "match.missionStatus": "Mission status",
  "match.neonMoonHeist": "Neon Moon Heist",
  "match.round": "Round {round}/6",
  "match.agents": "Agents",
  "match.radioFeed": "Radio feed",
  "match.planningCards": "Planning cards",
  "match.briefing": "Briefing",
  "match.chooseLie": "Choose a clean lie before the vault starts listening.",
  "match.aiSpectacle": "AI spectacle",
  "match.letAgentsCollide": "Let agents collide",
  "match.nextExecutionBeat": "Run the next execution beat.",
  "match.execute": "Execute",
  "radar.exit": "Exit",
  "radar.carrier": "Carrier",
  "radar.target": "Target",
  "final.scorePopup": "Score popup",
  "final.escapeBonus": "+{escape} Escape bonus",
  "final.cashoutDetail": "Cashout {cashout}{boost}",
  "final.afterburnerDetail": " · Afterburner +{boost}",
  "final.noRelics": "No relics banked",
  "final.eyebrow": "Final Case File",
  "final.shareCaseStamp": "Share case stamp",
  "final.localBestCase": "Local best case",
  "final.finalScores": "Final scores",
  "final.winner": "Winner",
  "final.tie": "Tie",
  "final.blueCrew": "Blue Crew",
  "final.redCrew": "Red Crew",
  "final.scoreMargin": "Score Margin",
  "final.runRating": "Run Rating",
  "final.cleanExitBonus": "Clean exit bonus +{bonus}",
  "final.noCleanBonus": "No clean bonus",
  "final.afterburnerExit": "Afterburner Exit",
  "final.boostCashout": "Boost cashout",
  "final.breakoutCashout": "Breakout Cashout",
  "final.rookLockBroken": "Rook lock broken",
  "final.comebackCashout": "Comeback Cashout",
  "final.beatRedBehind": "Beat Red from behind",
  "final.lootChain": "Loot Chain",
  "final.greedSuccessful": "Greed route successful",
  "final.mainRouteOnly": "Main route only",
  "final.relicsStolen": "Relics Stolen",
  "final.rivalRelics": "Rival Relics",
  "final.pendingCarrierLoot": "Pending Carrier Loot",
  "final.alibiPulses": "Alibi Pulses",
  "final.scannerJams": "Scanner jams",
  "final.carrierIntercepts": "Carrier Intercepts",
  "final.redDenied": "Red denied: {relics}",
  "final.redDeniedRecovered": "Red denied: recovered loot",
  "final.ambushDodges": "Ambush Dodges",
  "final.rivalAmbushDashed": "Rival ambush dashed",
  "final.scanBurns": "Scan Burns",
  "final.alarmSpikes": "Alarm spikes",
  "final.blueScoreDetail": "{loot} loot · {escape} escape",
  "final.redScoreDetail": "{loot} rival loot",
  "final.caseHighlights": "Case highlights",
  "final.rematchHook": "Rematch hook",
  "final.nextRunContracts": "Next run contracts",
  "final.runItBack": "Run It Back",
  "final.newContract": "New contract",
  "final.copyResult": "Copy Result",
  "final.copied": "Copied",
  "final.copyBlocked": "Copy blocked",
  "final.home": "Home",
  "final.manualShareFallback": "Manual share fallback",
  "final.clipboardBlocked": "Clipboard blocked",
  "final.manualCopy": "Select and copy this case file manually.",
  "final.manualCaseFileText": "Manual case file text",
  "final.caseStampKicker": "Agent Alibi Case File",
  "final.tieRun": "Tie run",
  "final.blueCrewWins": "Blue Crew wins",
  "final.redCrewWins": "Red Crew wins",
  "final.lootChainCompact": "Loot chain x{chain}",
  "final.tieGame": "Tie game",
  "final.blueBy": "Blue by {margin}",
  "final.redBy": "Red by {margin}",
  "final.comebackBeatRed": "Comeback cashout beat Red from behind",
  "final.shareHighlights": "CASE HIGHLIGHTS",
  "final.shareNextRun": "NEXT RUN",
  "final.sharePlay": "PLAY",
  "final.breakoutCashoutQuote": "Breakout cashout +{bonus}",
  "final.afterburnerCashoutQuote": "Afterburner cashout +{bonus}",
  "final.cashoutQuoteWithBase": "{prefix} · {quote}",
  "best.newBest": "New best case",
  "best.toBeat": "Best case to beat",
  "best.firstSaved": "First record saved",
  "best.overPrevious": "+{score} over previous",
  "best.pointsToBeat": "{score} points to beat",
  "best.detail": "Score {score} · {rating} · chain x{chain}{boost}{breakout}{denial}",
  "best.boost": " · boost +{boost}",
  "best.breakout": " · breakout +{breakout}",
  "best.denial": " · denial x{denial}",
  "best.bestCurrent": "Best {best} · current {current}",
  "contract.carrierHunt.label": "Carrier hunt",
  "contract.carrierHunt.title": "Deny Red loot",
  "contract.carrierHunt.detail": "Intercept the carrier before the Atrium Lift.",
  "contract.tempo.label": "Tempo",
  "contract.tempo.title": "Score first",
  "contract.tempo.detail": "Steal Moon Pearl before rival routes wake.",
  "contract.cashout.label": "Cashout",
  "contract.cashout.title": "Bank the swing",
  "contract.cashout.detail": "Escape with recovered loot before lockdown.",
  "contract.denial.label": "Denial",
  "contract.denial.title": "Deny the lift again",
  "contract.denial.detail": "Bait Red into carrying loot, then intercept before Atrium Lift.",
  "contract.bankRecovered.title": "Bank recovered loot",
  "contract.bankRecovered.detail": "Turn the stolen carrier relic into your own clean exit.",
  "contract.scoreBeforeBait.title": "Score before bait",
  "contract.scoreBeforeBait.detail": "Steal Moon Pearl early so Red has to answer your route.",
  "contract.relicFirst.label": "Relic first",
  "contract.relicFirst.title": "Steal before lift",
  "contract.relicFirst.detail": "Grab Moon Pearl before calling the escape.",
  "contract.value.label": "Value",
  "contract.value.title": "Bank one relic",
  "contract.value.detail": "Turn the escape bonus into a real cashout.",
  "contract.route.label": "Route",
  "contract.route.title": "Follow gold",
  "contract.route.detail": "Use the target beam until the first score lands.",
  "contract.boost.label": "Boost",
  "contract.boost.title": "Afterburner encore",
  "contract.boost.detail": "Steal, trigger afterburner, and cashout before the boost dies.",
  "contract.speedrun.label": "Speedrun",
  "contract.speedrun.title": "Beat your case",
  "contract.speedrun.detail": "Cashout faster without losing the loot chain.",
  "contract.cleanPlay.label": "Clean play",
  "contract.cleanPlay.title": "No scan burns",
  "contract.cleanPlay.detail": "Jam or dodge every rival scan.",
  "contract.encore.label": "Encore",
  "contract.encore.title": "Greed route encore",
  "contract.encore.detail": "Press G after Moon Pearl and bank the chain again.",
  "contract.rankPush.label": "Rank push",
  "contract.rankPush.title": "Chase S-Rank",
  "contract.rankPush.detail": "Cashout faster and keep the alarm low.",
  "contract.cleanExit.label": "Clean exit",
  "contract.cleanExit.title": "Avoid scan burns",
  "contract.cleanExit.detail": "Use alibi pulse before the meter spikes.",
  "contract.risk.label": "Risk",
  "contract.risk.title": "Try greed route",
  "contract.risk.detail": "Press G after Moon Pearl for a louder case.",
  "contract.scoreFirst.title": "Score first",
  "contract.scoreFirst.detail": "Turn the opening route into immediate loot.",
  "contract.runToLift.title": "Run to lift",
  "contract.runToLift.detail": "Bank the relic before Red finds an angle.",
  "contract.style.label": "Style",
  "contract.style.title": "Make it louder",
  "contract.style.detail": "Chain one more relic or deny a carrier.",
  "rematch.redWon": "Next run: deny the carrier before Red reaches the Atrium Lift.",
  "rematch.carrierIntercept": "Next run: bait another Red carrier run, then deny the lift again.",
  "rematch.emptyEscape": "Next run: steal one relic before you call the lift.",
  "rematch.lockBreak": "Next run: break Rook's lock, then cashout before the scan returns.",
  "rematch.afterburner": "Next run: hit afterburner again and cashout before the boost dies.",
  "rematch.rank": "Next run: chase S-Rank with a faster, lower-alarm cashout.",
  "rematch.chain": "Next run: press G after the first relic to push the loot chain.",
  "rematch.default": "Next run: run it back and make the case file louder."
} as const;

type TranslationKey = keyof typeof en;
type TranslationMap = Record<TranslationKey, string>;

const ru: TranslationMap = {
  ...en,
  "language.label": "Язык",
  "sound.on": "Звук вкл",
  "sound.off": "Звук выкл",
  "home.eyebrow": "Неоновое лунное ограбление / шесть раундов / люди + AI",
  "home.copy": "Выберите план, смотрите как агенты врут среди лазеров, крадите лунные реликвии и сбегайте до запечатывания хранилища.",
  "home.playNow": "Играть против AI",
  "home.createRoom": "Создать комнату",
  "home.aiDemo": "AI против AI",
  "home.bestCase": "Лучшее дело",
  "home.repeatDenial": "Повторить перехват",
  "home.beatCase": "Побить рекорд",
  "match.breachSprint": "Рывок взлома",
  "match.breachSprintSmall": "{seconds}с старт · держитесь золотой трассы",
  "match.openingContract": "Контракт Лунного хранилища",
  "match.stealMoonPearl": "Украдите Лунную жемчужину +3",
  "match.stealValue": "Украсть +{value}",
  "match.stealShort": "Украсть +3",
  "match.escapeShort": "Выход",
  "match.alibiShort": "Алиби",
  "match.dashShort": "Рывок",
  "match.moonPearlRoute": "Лунная жемчужина - {route}",
  "match.cashoutAtrium": "Сдать добычу у лифта Атриума",
  "match.pressAtRelic": "E / Space рядом с реликвией",
  "match.moonVaultRun": "Забег Лунного хранилища",
  "match.timer": "Таймер",
  "match.loot": "Добыча",
  "match.alarm": "Тревога",
  "match.radar": "Радар",
  "match.radio": "Радио",
  "match.sweepClear": "Сектор чист",
  "match.blueCarrying": "Blue несёт +{loot}",
  "match.blueScore": "Blue {loot}",
  "match.redPending": "AI {loot} (+{pending} в пути)",
  "match.redScore": "AI {loot}",
  "match.redRacePending": "Red {loot} (+{pending} в пути)",
  "match.redRace": "Red {loot}",
  "match.recoverBeforeRed": "Верните +{pending}, пока Red не сдал",
  "match.bankAtLift": "Сдать +{cashout} у лифта",
  "match.lootRaceTied": "Гонка добычи равная",
  "match.escape": "Побег",
  "match.cashoutStep": "Сдать +{cashout}",
  "match.ghostSpeedSmall": "{seconds}с ускорение · чистый побег",
  "match.extractionLive": "Эвакуация активна",
  "match.cashoutBanked": "Добыча сдана +{cashout}",
  "match.untilCaseFile": "{seconds}с до дела",
  "match.runToLift": "Бегите к лифту",
  "match.bankValue": "Сдать +{cashout}",
  "match.afterburnerExit": "Форсаж выхода +1",
  "match.ghostCleanEscape": "Ghost Step: чистый побег",
  "match.beforeScans": "{seconds}с до сканов · сдача или риск",
  "match.hunterLockOn": "{agentName}: захват",
  "match.dashBreakLock": "Рывок сбивает захват",
  "match.hunterClosing": "{distance}м до вас · лучей: {beams}",
  "match.redCashoutImminent": "Red почти сдаёт добычу",
  "match.interceptNow": "Перехватить сейчас",
  "match.denySwing": "Сорвать Red +{value} / swing +{swing}",
  "match.agentLiftDistance": "{agentName}: {distance}м до лифта · {seconds}с",
  "match.lockBroken": "Захват сбит",
  "match.breakoutCashout": "Прорывная сдача +{cashout}",
  "match.bankNow": "Сдать сейчас",
  "match.lootBreakout": "+{base} добыча +{bonus} прорыв",
  "match.rookScanJammed": "Скан Rook заглушен · {seconds}с до сдачи",
  "match.bonus": "+{bonus} бонус",
  "match.cashoutValue": "Сдать +{cashout}",
  "match.secondsToBank": "{seconds}с до сдачи",
  "match.scanLock": "Скан-захват",
  "match.pressInteract": "Нажмите E / Space",
  "match.jamScan": "Заглушите скан до всплеска тревоги",
  "match.optionalRisk": "Риск по желанию",
  "match.cashoutWindow": "Окно сдачи",
  "match.primaryTarget": "Главная цель",
  "match.vaultStable": "Хранилище стабильно",
  "match.lowProfile": "Низкий профиль",
  "match.heistRace": "Гонка ограбления",
  "match.rivalIntel": "Разведка Red",
  "match.rivalCarrying": "{agentName} несёт добычу",
  "match.carryingLoot": "Несёте +{loot}",
  "match.escapeBonus": "Бонус побега +{bonus}",
  "match.cashoutPlain": "Сдача {cashout}",
  "match.greedArmed": "Риск-ветка активна",
  "match.greedRoute": "Риск-маршрут",
  "match.bankNowValue": "Сдать +{cashout} сейчас",
  "match.safeExitLoot": "Безопасный выход с +{loot} добычи",
  "match.riskRelic": "Риск +{value}: {relicName}",
  "match.projectedCashout": "Прогноз сдачи +{cashout} · {distance}м до реликвии",
  "match.pressGForCashout": "G: сдача +{cashout} · обход {distance}м",
  "match.targetPlotting": "Строим маршрут",
  "match.rivalsScanning": "Соперники сканируют",
  "match.nearestRivalScanning": "Поиск ближайшего соперника",
  "match.scanClear": "Скан чист",
  "match.paceUnknown": "Темп неизвестен",
  "match.momentum": "Темп",
  "match.secondsLeft": "{seconds}с осталось",
  "match.dashCooling": "Рывок перезаряжается",
  "match.dashReady": "Рывок готов",
  "match.alibiReady": "Алиби готово",
  "match.move": "Двигаться",
  "match.followMarker": "Следовать маркеру",
  "match.lockdown": "Блокировка",
  "match.alarmRising": "Тревога растёт",
  "match.heistLive": "Ограбление идёт",
  "match.defaultObjective": "Украдите реликвию до того, как хранилище запомнит ваше имя",
  "match.target": "Цель",
  "radar.exit": "Выход",
  "radar.carrier": "Носитель",
  "radar.target": "Цель",
  "match.final30": "Финал 30с",
  "match.escapeNow": "Сбегайте",
  "match.cashoutNow": "Сдайте добычу",
  "match.beforeVaultSeals": "{time} до запечатывания",
  "match.controls": "WASD / стрелки - движение · клик - бег · Shift - рывок · E / Space - действие · G - маршрут",
  "final.eyebrow": "Финальное дело",
  "final.winner": "Победитель",
  "final.scoreMargin": "Разница очков",
  "final.runRating": "Рейтинг забега",
  "final.runItBack": "Ещё забег",
  "final.copyResult": "Копировать итог",
  "final.home": "Домой",
  "final.scorePopup": "Начисление очков",
  "final.escapeBonus": "+{escape} бонус побега",
  "final.cashoutDetail": "Сдача {cashout}{boost}",
  "final.afterburnerDetail": " · форсаж +{boost}",
  "final.noRelics": "Реликвии не сданы",
  "final.shareCaseStamp": "Карточка для шаринга",
  "final.localBestCase": "Личный лучший забег",
  "final.finalScores": "Финальные очки",
  "final.tie": "Ничья",
  "final.blueCrew": "Blue Crew",
  "final.redCrew": "Red Crew",
  "final.cleanExitBonus": "Чистый бонус +{bonus}",
  "final.noCleanBonus": "Без чистого бонуса",
  "final.afterburnerExit": "Форсаж выхода",
  "final.boostCashout": "Буст сдачи",
  "final.breakoutCashout": "Прорывная сдача",
  "final.rookLockBroken": "Захват Rook сбит",
  "final.comebackCashout": "Камбэк-сдача",
  "final.beatRedBehind": "Обгон Red сзади",
  "final.lootChain": "Цепочка добычи",
  "final.greedSuccessful": "Риск-маршрут успешен",
  "final.mainRouteOnly": "Только основной маршрут",
  "final.relicsStolen": "Реликвий украдено",
  "final.rivalRelics": "Реликвии соперников",
  "final.pendingCarrierLoot": "Добыча у носителя",
  "final.alibiPulses": "Импульсы алиби",
  "final.scannerJams": "Глушение сканера",
  "final.carrierIntercepts": "Перехваты носителя",
  "final.redDenied": "Red сорван: {relics}",
  "final.redDeniedRecovered": "Red сорван: добыча возвращена",
  "final.ambushDodges": "Уходы от засады",
  "final.rivalAmbushDashed": "Засада соперника сорвана рывком",
  "final.scanBurns": "Ожоги скана",
  "final.alarmSpikes": "Всплески тревоги",
  "final.blueScoreDetail": "{loot} добыча · {escape} побег",
  "final.redScoreDetail": "{loot} добыча соперников",
  "final.caseHighlights": "Ключевые моменты дела",
  "final.rematchHook": "Хук реванша",
  "final.nextRunContracts": "Контракты следующего забега",
  "final.newContract": "Новый контракт",
  "final.copied": "Скопировано",
  "final.copyBlocked": "Копирование заблокировано",
  "final.manualShareFallback": "Ручной шаринг",
  "final.clipboardBlocked": "Буфер обмена заблокирован",
  "final.manualCopy": "Выделите и скопируйте это дело вручную.",
  "final.manualCaseFileText": "Текст дела для копирования",
  "final.caseStampKicker": "Дело Agent Alibi",
  "final.tieRun": "Ничейный забег",
  "final.blueCrewWins": "Blue Crew победила",
  "final.redCrewWins": "Red Crew победила",
  "final.lootChainCompact": "Цепочка добычи x{chain}",
  "final.tieGame": "Ничья",
  "final.blueBy": "Blue впереди на {margin}",
  "final.redBy": "Red впереди на {margin}",
  "final.comebackBeatRed": "Камбэк-сдача обошла Red",
  "final.shareHighlights": "КЛЮЧЕВЫЕ МОМЕНТЫ",
  "final.shareNextRun": "СЛЕДУЮЩИЙ ЗАБЕГ",
  "final.sharePlay": "ИГРАТЬ",
  "final.breakoutCashoutQuote": "Прорывная сдача +{bonus}",
  "final.afterburnerCashoutQuote": "Форсажная сдача +{bonus}",
  "final.cashoutQuoteWithBase": "{prefix} · {quote}",
  "best.newBest": "Новое лучшее дело",
  "best.toBeat": "Лучшее дело для побития",
  "best.firstSaved": "Первый рекорд сохранён",
  "best.overPrevious": "+{score} к прошлому",
  "best.pointsToBeat": "{score} очков до рекорда",
  "best.detail": "Очки {score} · {rating} · цепочка x{chain}{boost}{breakout}{denial}",
  "best.boost": " · буст +{boost}",
  "best.breakout": " · прорыв +{breakout}",
  "best.denial": " · перехват x{denial}",
  "best.bestCurrent": "Лучший {best} · текущий {current}",
  "contract.carrierHunt.label": "Охота",
  "contract.carrierHunt.title": "Сорвать добычу Red",
  "contract.carrierHunt.detail": "Перехватите носителя до Лифта Атриума.",
  "contract.tempo.label": "Темп",
  "contract.tempo.title": "Сначала счёт",
  "contract.tempo.detail": "Украдите Лунную жемчужину до пробуждения соперников.",
  "contract.cashout.label": "Сдача",
  "contract.cashout.title": "Сдать swing",
  "contract.cashout.detail": "Сбегите с возвращённой добычей до блокировки.",
  "contract.denial.label": "Перехват",
  "contract.denial.title": "Сорвать лифт снова",
  "contract.denial.detail": "Спровоцируйте Red на перенос добычи, затем перехватите до Лифта Атриума.",
  "contract.bankRecovered.title": "Сдать возвращённую добычу",
  "contract.bankRecovered.detail": "Превратите реликвию носителя в свой чистый выход.",
  "contract.scoreBeforeBait.title": "Счёт до приманки",
  "contract.scoreBeforeBait.detail": "Украдите Лунную жемчужину рано, чтобы Red отвечала на ваш маршрут.",
  "contract.relicFirst.label": "Сначала реликвия",
  "contract.relicFirst.title": "Украдите до лифта",
  "contract.relicFirst.detail": "Заберите Лунную жемчужину до вызова эвакуации.",
  "contract.value.label": "Ценность",
  "contract.value.title": "Сдать одну реликвию",
  "contract.value.detail": "Превратите бонус побега в настоящую сдачу.",
  "contract.route.label": "Маршрут",
  "contract.route.title": "Следовать золоту",
  "contract.route.detail": "Держитесь целевого луча до первого счёта.",
  "contract.boost.label": "Буст",
  "contract.boost.title": "Форсаж на бис",
  "contract.boost.detail": "Украдите, включите форсаж и сдайте добычу до конца буста.",
  "contract.speedrun.label": "Спидран",
  "contract.speedrun.title": "Побить своё дело",
  "contract.speedrun.detail": "Сдайте добычу быстрее, не потеряв цепочку.",
  "contract.cleanPlay.label": "Чистая игра",
  "contract.cleanPlay.title": "Без ожогов скана",
  "contract.cleanPlay.detail": "Глушите или избегайте каждый скан соперников.",
  "contract.encore.label": "На бис",
  "contract.encore.title": "Риск-маршрут снова",
  "contract.encore.detail": "Нажмите G после Лунной жемчужины и снова сдайте цепочку.",
  "contract.rankPush.label": "Ранг",
  "contract.rankPush.title": "Гонка за S-Rank",
  "contract.rankPush.detail": "Сдайте быстрее и удержите тревогу ниже.",
  "contract.cleanExit.label": "Чистый выход",
  "contract.cleanExit.title": "Избежать ожогов скана",
  "contract.cleanExit.detail": "Используйте импульс алиби до всплеска шкалы.",
  "contract.risk.label": "Риск",
  "contract.risk.title": "Попробовать риск-маршрут",
  "contract.risk.detail": "Нажмите G после Лунной жемчужины для более громкого дела.",
  "contract.scoreFirst.title": "Сначала счёт",
  "contract.scoreFirst.detail": "Превратите стартовый маршрут в быструю добычу.",
  "contract.runToLift.title": "Бежать к лифту",
  "contract.runToLift.detail": "Сдайте реликвию до того, как Red найдёт угол атаки.",
  "contract.style.label": "Стиль",
  "contract.style.title": "Сделать громче",
  "contract.style.detail": "Сцепите ещё одну реликвию или сорвите носителя.",
  "rematch.redWon": "Следующий забег: сорвите носителя до Лифта Атриума.",
  "rematch.carrierIntercept": "Следующий забег: спровоцируйте новый забег носителя Red и снова сорвите лифт.",
  "rematch.emptyEscape": "Следующий забег: украдите хотя бы одну реликвию до вызова лифта.",
  "rematch.lockBreak": "Следующий забег: сломайте захват Rook и сдайте добычу до возврата скана.",
  "rematch.afterburner": "Следующий забег: снова включите форсаж и сдайте добычу до конца буста.",
  "rematch.rank": "Следующий забег: гонитесь за S-Rank с более быстрой сдачей и низкой тревогой.",
  "rematch.chain": "Следующий забег: нажмите G после первой реликвии, чтобы усилить цепочку добычи.",
  "rematch.default": "Следующий забег: повторите и сделайте дело громче."
};

const zh: TranslationMap = {
  ...en,
  "language.label": "语言",
  "sound.on": "声音开",
  "sound.off": "声音关",
  "home.eyebrow": "霓虹月球劫案 / 六轮 / 人类 + AI 队员",
  "home.copy": "选择计划，看特工在激光中撒谎，偷走月球遗物，并在金库封死前逃离。",
  "home.playNow": "立即对战 AI",
  "home.createRoom": "创建房间",
  "home.aiDemo": "AI 对战演示",
  "home.bestCase": "最佳档案",
  "home.repeatDenial": "重玩拦截局",
  "home.beatCase": "刷新档案",
  "match.breachSprint": "突破冲刺",
  "match.breachSprintSmall": "{seconds}秒起跑 · 跟随金色跑道",
  "match.openingContract": "月库合约",
  "match.stealMoonPearl": "偷取月亮珍珠 +3",
  "match.stealValue": "偷 +{value}",
  "match.stealShort": "偷 +3",
  "match.escapeShort": "撤离",
  "match.alibiShort": "掩护",
  "match.dashShort": "冲刺",
  "match.moonPearlRoute": "月亮珍珠 - {route}",
  "match.cashoutAtrium": "在中庭升降梯结算",
  "match.pressAtRelic": "在遗物旁按 E / Space",
  "match.moonVaultRun": "月库行动",
  "match.timer": "计时",
  "match.loot": "战利品",
  "match.alarm": "警报",
  "match.radar": "雷达",
  "match.radio": "电台",
  "match.sweepClear": "扫描清空",
  "match.blueCarrying": "Blue 携带 +{loot}",
  "match.blueScore": "Blue {loot}",
  "match.redPending": "AI {loot}（+{pending} 未结算）",
  "match.redScore": "AI {loot}",
  "match.redRacePending": "Red {loot}（+{pending} 未结算）",
  "match.redRace": "Red {loot}",
  "match.recoverBeforeRed": "在 Red 结算前夺回 +{pending}",
  "match.bankAtLift": "在升降梯结算 +{cashout}",
  "match.lootRaceTied": "战利品竞赛持平",
  "match.escape": "撤离",
  "match.cashoutStep": "结算 +{cashout}",
  "match.ghostSpeedSmall": "{seconds}秒加速 · 干净撤离",
  "match.extractionLive": "撤离进行中",
  "match.cashoutBanked": "已结算 +{cashout}",
  "match.untilCaseFile": "{seconds}秒后生成档案",
  "match.runToLift": "冲向升降梯",
  "match.bankValue": "结算 +{cashout}",
  "match.afterburnerExit": "后燃撤离 +1",
  "match.ghostCleanEscape": "幽步干净撤离",
  "match.beforeScans": "{seconds}秒后扫描 · 结算或贪心",
  "match.hunterLockOn": "{agentName} 锁定",
  "match.dashBreakLock": "冲刺解除锁定",
  "match.hunterClosing": "距离 {distance}米 · {beams} 道光束",
  "match.redCashoutImminent": "Red 即将结算",
  "match.interceptNow": "立即拦截",
  "match.denySwing": "阻止 Red +{value} / 摇摆 +{swing}",
  "match.agentLiftDistance": "{agentName} 距升降梯 {distance}米 · {seconds}秒",
  "match.lockBroken": "锁定已解除",
  "match.breakoutCashout": "突破结算 +{cashout}",
  "match.bankNow": "立即结算",
  "match.lootBreakout": "+{base} 战利品 +{bonus} 突破",
  "match.rookScanJammed": "Rook 扫描已干扰 · {seconds}秒可结算",
  "match.bonus": "+{bonus} 奖励",
  "match.cashoutValue": "结算 +{cashout}",
  "match.secondsToBank": "{seconds}秒内结算",
  "match.scanLock": "扫描锁定",
  "match.pressInteract": "按 E / Space",
  "match.jamScan": "在警报烧穿前干扰扫描",
  "match.optionalRisk": "可选风险",
  "match.cashoutWindow": "结算窗口",
  "match.primaryTarget": "主要目标",
  "match.vaultStable": "金库稳定",
  "match.lowProfile": "低调潜入",
  "match.heistRace": "劫案竞速",
  "match.rivalIntel": "对手情报",
  "match.rivalCarrying": "{agentName} 正在携带",
  "match.carryingLoot": "携带 +{loot}",
  "match.escapeBonus": "撤离奖励 +{bonus}",
  "match.cashoutPlain": "结算 {cashout}",
  "match.greedArmed": "贪心路线已激活",
  "match.greedRoute": "贪心路线",
  "match.bankNowValue": "立即结算 +{cashout}",
  "match.safeExitLoot": "安全撤离，携带 +{loot} 战利品",
  "match.riskRelic": "风险 +{value}: {relicName}",
  "match.projectedCashout": "预计结算 +{cashout} · 距遗物 {distance}米",
  "match.pressGForCashout": "按 G 结算 +{cashout} · 绕路 {distance}米",
  "match.targetPlotting": "正在规划目标",
  "match.rivalsScanning": "对手正在扫描",
  "match.nearestRivalScanning": "正在扫描最近对手",
  "match.scanClear": "扫描安全",
  "match.paceUnknown": "节奏未知",
  "match.momentum": "动量",
  "match.secondsLeft": "剩余 {seconds}秒",
  "match.dashCooling": "冲刺冷却中",
  "match.dashReady": "冲刺就绪",
  "match.alibiReady": "托辞脉冲就绪",
  "match.move": "移动",
  "match.followMarker": "跟随标记",
  "match.lockdown": "封锁",
  "match.alarmRising": "警报上升",
  "match.heistLive": "劫案进行中",
  "match.defaultObjective": "在金库记住你之前偷走一件遗物",
  "match.target": "目标",
  "radar.exit": "出口",
  "radar.carrier": "携带者",
  "radar.target": "目标",
  "match.final30": "最后30秒",
  "match.escapeNow": "立即撤离",
  "match.cashoutNow": "立即结算",
  "match.beforeVaultSeals": "{time} 后金库封闭",
  "match.controls": "WASD / 方向键移动 · 点击奔跑 · Shift 冲刺 · E / Space 互动 · G 切路线",
  "final.eyebrow": "最终档案",
  "final.winner": "胜者",
  "final.scoreMargin": "分差",
  "final.runRating": "行动评级",
  "final.runItBack": "再来一局",
  "final.copyResult": "复制结果",
  "final.home": "主页",
  "final.scorePopup": "得分弹窗",
  "final.escapeBonus": "+{escape} 撤离奖励",
  "final.cashoutDetail": "结算 {cashout}{boost}",
  "final.afterburnerDetail": " · 后燃 +{boost}",
  "final.noRelics": "没有结算遗物",
  "final.shareCaseStamp": "分享档案卡",
  "final.localBestCase": "本地最佳档案",
  "final.finalScores": "最终得分",
  "final.tie": "平局",
  "final.blueCrew": "蓝队",
  "final.redCrew": "红队",
  "final.cleanExitBonus": "干净撤离奖励 +{bonus}",
  "final.noCleanBonus": "没有干净奖励",
  "final.afterburnerExit": "后燃撤离",
  "final.boostCashout": "加速结算",
  "final.breakoutCashout": "突破结算",
  "final.rookLockBroken": "Rook 锁定已解除",
  "final.comebackCashout": "反超结算",
  "final.beatRedBehind": "从落后反超 Red",
  "final.lootChain": "战利品连锁",
  "final.greedSuccessful": "贪心路线成功",
  "final.mainRouteOnly": "仅主路线",
  "final.relicsStolen": "偷取遗物",
  "final.rivalRelics": "对手遗物",
  "final.pendingCarrierLoot": "携带者未结算战利品",
  "final.alibiPulses": "托辞脉冲",
  "final.scannerJams": "扫描干扰",
  "final.carrierIntercepts": "携带者拦截",
  "final.redDenied": "Red 被阻止：{relics}",
  "final.redDeniedRecovered": "Red 被阻止：夺回战利品",
  "final.ambushDodges": "躲过伏击",
  "final.rivalAmbushDashed": "冲刺摆脱对手伏击",
  "final.scanBurns": "扫描灼伤",
  "final.alarmSpikes": "警报尖峰",
  "final.blueScoreDetail": "{loot} 战利品 · {escape} 撤离",
  "final.redScoreDetail": "{loot} 对手战利品",
  "final.caseHighlights": "档案亮点",
  "final.rematchHook": "重赛钩子",
  "final.nextRunContracts": "下一局合约",
  "final.newContract": "新合约",
  "final.copied": "已复制",
  "final.copyBlocked": "复制被阻止",
  "final.manualShareFallback": "手动分享备用",
  "final.clipboardBlocked": "剪贴板被阻止",
  "final.manualCopy": "请手动选择并复制这份档案。",
  "final.manualCaseFileText": "手动复制档案文本",
  "final.caseStampKicker": "Agent Alibi 档案",
  "final.tieRun": "平局行动",
  "final.blueCrewWins": "蓝队获胜",
  "final.redCrewWins": "红队获胜",
  "final.lootChainCompact": "战利品连锁 x{chain}",
  "final.tieGame": "平局",
  "final.blueBy": "蓝队领先 {margin}",
  "final.redBy": "红队领先 {margin}",
  "final.comebackBeatRed": "反超结算击败 Red",
  "final.shareHighlights": "档案亮点",
  "final.shareNextRun": "下一局",
  "final.sharePlay": "游玩",
  "final.breakoutCashoutQuote": "突破结算 +{bonus}",
  "final.afterburnerCashoutQuote": "后燃结算 +{bonus}",
  "final.cashoutQuoteWithBase": "{prefix} · {quote}",
  "best.newBest": "新的最佳档案",
  "best.toBeat": "待刷新最佳档案",
  "best.firstSaved": "已保存首个记录",
  "best.overPrevious": "比上次高 +{score}",
  "best.pointsToBeat": "还差 {score} 分刷新",
  "best.detail": "得分 {score} · {rating} · 连锁 x{chain}{boost}{breakout}{denial}",
  "best.boost": " · 加速 +{boost}",
  "best.breakout": " · 突破 +{breakout}",
  "best.denial": " · 拦截 x{denial}",
  "best.bestCurrent": "最佳 {best} · 当前 {current}",
  "contract.carrierHunt.label": "追猎",
  "contract.carrierHunt.title": "阻止 Red 战利品",
  "contract.carrierHunt.detail": "在中庭升降梯前拦截携带者。",
  "contract.tempo.label": "节奏",
  "contract.tempo.title": "先得分",
  "contract.tempo.detail": "在对手路线启动前偷取月亮珍珠。",
  "contract.cashout.label": "结算",
  "contract.cashout.title": "结算摇摆分",
  "contract.cashout.detail": "在封锁前带着夺回的战利品撤离。",
  "contract.denial.label": "拦截",
  "contract.denial.title": "再次阻止升降梯",
  "contract.denial.detail": "诱导 Red 携带战利品，再在中庭升降梯前拦截。",
  "contract.bankRecovered.title": "结算夺回战利品",
  "contract.bankRecovered.detail": "把夺来的携带者遗物变成自己的干净撤离。",
  "contract.scoreBeforeBait.title": "诱饵前先得分",
  "contract.scoreBeforeBait.detail": "早点偷取月亮珍珠，让 Red 必须回应你的路线。",
  "contract.relicFirst.label": "先拿遗物",
  "contract.relicFirst.title": "升降梯前先偷取",
  "contract.relicFirst.detail": "在呼叫撤离前拿到月亮珍珠。",
  "contract.value.label": "价值",
  "contract.value.title": "结算一件遗物",
  "contract.value.detail": "把撤离奖励变成真正的结算。",
  "contract.route.label": "路线",
  "contract.route.title": "跟随金色",
  "contract.route.detail": "沿目标光束直到首次得分。",
  "contract.boost.label": "加速",
  "contract.boost.title": "后燃再演",
  "contract.boost.detail": "偷取、触发后燃，并在加速结束前结算。",
  "contract.speedrun.label": "速通",
  "contract.speedrun.title": "刷新档案",
  "contract.speedrun.detail": "更快结算，同时保住战利品连锁。",
  "contract.cleanPlay.label": "干净行动",
  "contract.cleanPlay.title": "无扫描灼伤",
  "contract.cleanPlay.detail": "干扰或躲过每一次对手扫描。",
  "contract.encore.label": "再演",
  "contract.encore.title": "贪心路线再演",
  "contract.encore.detail": "拿到月亮珍珠后按 G，再次结算连锁。",
  "contract.rankPush.label": "评级冲刺",
  "contract.rankPush.title": "冲击 S-Rank",
  "contract.rankPush.detail": "更快结算并保持低警报。",
  "contract.cleanExit.label": "干净撤离",
  "contract.cleanExit.title": "避免扫描灼伤",
  "contract.cleanExit.detail": "在计量条尖峰前使用托辞脉冲。",
  "contract.risk.label": "风险",
  "contract.risk.title": "尝试贪心路线",
  "contract.risk.detail": "拿到月亮珍珠后按 G，打出更响亮的档案。",
  "contract.scoreFirst.title": "先得分",
  "contract.scoreFirst.detail": "把开局路线转化成立即战利品。",
  "contract.runToLift.title": "冲向升降梯",
  "contract.runToLift.detail": "在 Red 找到机会前结算遗物。",
  "contract.style.label": "风格",
  "contract.style.title": "更响亮一点",
  "contract.style.detail": "再连一件遗物，或拦截一个携带者。",
  "rematch.redWon": "下一局：在 Red 抵达中庭升降梯前阻止携带者。",
  "rematch.carrierIntercept": "下一局：诱导另一次 Red 携带冲刺，然后再次阻止升降梯。",
  "rematch.emptyEscape": "下一局：呼叫升降梯前先偷一件遗物。",
  "rematch.lockBreak": "下一局：打破 Rook 锁定，并在扫描返回前结算。",
  "rematch.afterburner": "下一局：再次触发后燃，并在加速结束前结算。",
  "rematch.rank": "下一局：冲击 S-Rank，更快、更低警报结算。",
  "rematch.chain": "下一局：第一件遗物后按 G，推进战利品连锁。",
  "rematch.default": "下一局：再来一次，让档案更响亮。"
};

const translations: Record<Locale, TranslationMap> = { en, ru, zh };

export function isLocale(value: string | null | undefined): value is Locale {
  return value === "en" || value === "ru" || value === "zh";
}

export function readStoredLocale(): Locale {
  if (typeof window === "undefined") return "en";
  try {
    const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
    return isLocale(stored) ? stored : "en";
  } catch {
    return "en";
  }
}

export function writeStoredLocale(locale: Locale) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Locale stays in React state even when storage is blocked.
  }
}

export function t(locale: Locale, key: TranslationKey, values: Record<string, string | number> = {}): string {
  const template = translations[locale][key] ?? translations.en[key];
  return template.replace(/\{([a-zA-Z0-9_]+)\}/g, (_, token: string) => String(values[token] ?? `{${token}}`));
}

export function localizeText(locale: Locale, text: string | null | undefined): string {
  if (!text) return "";
  if (locale === "en") return text;
  const replacements = locale === "ru" ? ruTextReplacements : zhTextReplacements;
  return replacements.reduce((value, [pattern, replacement]) => value.replace(pattern, replacement), text);
}

const ruTextReplacements: Array<[RegExp, string]> = [
  [/Breach Sprint/gi, "Рывок взлома"],
  [/Ghost Step/gi, "Призрачный шаг"],
  [/Afterburner/gi, "Форсаж"],
  [/STEAL ROUTE/gi, "МАРШРУТ К РЕЛИКВИИ"],
  [/INTERCEPT ROUTE/gi, "МАРШРУТ ПЕРЕХВАТА"],
  [/COMEBACK ROUTE/gi, "МАРШРУТ КАМБЭКА"],
  [/EXIT ROUTE/gi, "МАРШРУТ ВЫХОДА"],
  [/BREAKOUT RUSH/gi, "РЫВОК ПРОРЫВА"],
  [/VAULT RUSH/gi, "РЫВОК ХРАНИЛИЩА"],
  [/Greed route armed/gi, "Маршрут жадности готов"],
  [/Cashout route armed/gi, "Маршрут сдачи готов"],
  [/Cashout \+(\d+) if you survive/gi, "Сдача +$1, если выживете"],
  [/Bank \+(\d+) at Atrium Lift/gi, "Сдать +$1 на Лифте Атриума"],
  [/Argent Crown marker live/gi, "Маркер Серебряной короны активен"],
  [/Atrium Lift marker live/gi, "Маркер Лифта Атриума активен"],
  [/BANK \+(\d+)/gi, "СДАТЬ +$1"],
  [/Cashout \+(\d+)/gi, "Сдача +$1"],
  [/CASHOUT \+(\d+)/gi, "СДАЧА +$1"],
  [/HIGH VALUE/gi, "ВЫСОКАЯ ЦЕННОСТЬ"],
  [/RIVAL ENTRY/gi, "ВХОД СОПЕРНИКОВ"],
  [/\bEXTRACT\b/gi, "ЭВАКУАЦИЯ"],
  [/ESCAPE LIFT/gi, "ЛИФТ ПОБЕГА"],
  [/RISK (\d+)/gi, "РИСК $1"],
  [/Risk \+(\d+)/gi, "Риск +$1"],
  [/PRESS G/gi, "НАЖМИТЕ G"],
  [/STANDBY/gi, "ОЖИДАНИЕ"],
  [/\bYOU\b/gi, "ВЫ"],
  [/Atrium Lift/gi, "Лифт Атриума"],
  [/Inner Vault/gi, "Внутреннее хранилище"],
  [/Vault Door/gi, "Дверь хранилища"],
  [/Moon Gallery/gi, "Лунная галерея"],
  [/Guard Post/gi, "Пост охраны"],
  [/Silver Archive/gi, "Серебряный архив"],
  [/Crystal Lift/gi, "Кристальный лифт"],
  [/East Hall/gi, "Восточный зал"],
  [/West Hall/gi, "Западный зал"],
  [/Atrium/gi, "Атриум"],
  [/Carrier/gi, "Носитель"],
  [/Hunter/gi, "Охотник"],
  [/Scanner/gi, "Сканер"],
  [/Raider/gi, "Рейдер"],
  [/Marks you/gi, "Метит вас"],
  [/Scan pressure/gi, "Скан-давление"],
  [/Raiding ([^\n]+)/gi, "Рейд: $1"],
  [/Cashout in (\d+)s · (\d+)m/gi, "Сдача через $1с · $2м"],
  [/Waking in (\d+)s · (\d+)m/gi, "Пробуждение через $1с · $2м"],
  [/Scan lock · (\d+)m/gi, "Скан-захват · $1м"],
  [/On you · (\d+)m/gi, "На вас · $1м"],
  [/Closing · (\d+)m/gi, "Сближение · $1м"],
  [/(\d+)m route/gi, "Маршрут $1м"],
  [/Intercept now/gi, "Перехватить сейчас"],
  [/Cut off before lift/gi, "Срезать до лифта"],
  [/Dash or break line/gi, "Рывок или разрыв линии"],
  [/Jam or break line/gi, "Заглушить или разорвать линию"],
  [/Beat them to loot/gi, "Обгоните их к добыче"],
  [/Use the head start/gi, "Используйте фору"],
  [/Moon Vault breach started\./gi, "Взлом Лунного хранилища начался."],
  [/Rival agents wait for your first score\./gi, "Соперники ждут вашего первого счёта."],
  [/Move fast\. Steal clean\. Escape before lockdown\./gi, "Двигайтесь быстро. Крадите чисто. Сбегайте до блокировки."],
  [/Moon Vault Contract/gi, "Контракт Лунного хранилища"],
  [/Stole Moon Pearl \+ Argent Crown/gi, "Украдены Лунная жемчужина + Серебряная корона"],
  [/Recovered Moon Pearl from rivals/gi, "Лунная жемчужина возвращена у соперников"],
  [/Comeback cashout beat Red from behind/gi, "Камбэк-сдача обошла Red"],
  [/Case title:/gi, "Название дела:"],
  [/Escaped with (\d+) loot/gi, "Побег с добычей $1"],
  [/Steal the Moon Pearl/gi, "Украдите Лунную жемчужину"],
  [/Steal Moon Pearl/gi, "Украдите Лунную жемчужину"],
  [/Stole Moon Pearl/gi, "Украдена Лунная жемчужина"],
  [/Stole Argent Crown/gi, "Украдена Серебряная корона"],
  [/STEAL MOON PEARL/gi, "УКРАДИТЕ ЛУННУЮ ЖЕМЧУЖИНУ"],
  [/Argent Crown/g, "Серебряная корона"],
  [/Silver Key/g, "Серебряный ключ"],
  [/Moon Pearl/g, "Лунная жемчужина"],
  [/First score wins tempo/gi, "Первый счёт задаёт темп"],
  [/Follow the gold marker/gi, "Следуйте за золотым маркером"],
  [/Follow gold beam/gi, "Следовать золотому лучу"],
  [/The gold marker points to the score\. Rivals arrive fast\./gi, "Золотой маркер ведёт к очкам. Соперники скоро рядом."],
  [/Follow the gold beam and steal \+(\d+) before Red wakes up\./gi, "Следуйте по золотому лучу и украдите +$1 до пробуждения Red."],
  [/First score unlocks the cashout route\./gi, "Первый счёт открывает маршрут сдачи добычи."],
  [/Move with WASD \/ ARROWS/gi, "Двигайтесь WASD / стрелками"],
  [/First hit:/gi, "Первый удар:"],
  [/First objective/gi, "Первая цель"],
  [/Director cue/gi, "Подсказка режиссёра"],
  [/Primary target/gi, "Главная цель"],
  [/Vault Stable/gi, "Хранилище стабильно"],
  [/Low Profile/gi, "Низкий профиль"],
  [/Optional risk/gi, "Риск по желанию"],
  [/Cashout window/gi, "Окно сдачи"],
  [/Steal relic/gi, "Украсть реликвию"],
  [/STEAL/gi, "УКРАСТЬ"],
  [/Move/gi, "Движение"],
  [/Break heat/gi, "Сбить преследование"],
  [/Follow marker/gi, "Следовать маркеру"],
  [/Close gap (\d+)m/gi, "Сократить разрыв $1м"],
  [/Press E \/ Space to intercept/gi, "E / Space: перехват"],
  [/Press E \/ Space to steal/gi, "E / Space: украсть"],
  [/Press E \/ Space to jam rival scan/gi, "E / Space: заглушить скан"],
  [/Red cashout imminent/gi, "Red почти сдаёт добычу"],
  [/Intercept ([^ ]+) before lift/gi, "Перехватить $1 до лифта"],
  [/Intercept carrier/gi, "Перехватить носителя"],
  [/Intercept/gi, "Перехват"],
  [/Recover ([^+]+) \+(\d+)/gi, "Вернуть $1 +$2"],
  [/Jam the rival scan/gi, "Заглушите скан соперника"],
  [/Target plotting/gi, "Строим маршрут"],
  [/Rivals scanning/gi, "Соперники сканируют"],
  [/Rivals wake after first score or (\d+)s/gi, "Соперники проснутся после первого счёта или через $1с"],
  [/Nearest rival scanning/gi, "Поиск ближайшего соперника"],
  [/Nearest rival ([A-Z]+ \d+m|HERE)/gi, "Ближайший соперник $1"],
  [/Scan clear/gi, "Скан чист"],
  [/S-Rank pace/gi, "Темп S-Rank"],
  [/Loot race is tied/gi, "Гонка добычи равная"],
  [/Target ([A-Z]+ \d+m|HERE)/gi, "Цель $1"],
  [/Pace unknown/gi, "Темп неизвестен"],
  [/Dash ready/gi, "Рывок готов"],
  [/Dash cooling/gi, "Рывок перезаряжается"],
  [/Alibi ready/gi, "Алиби готово"],
  [/(\d+)m away/gi, "$1м от вас"],
  [/(\d+)m to relic/gi, "$1м до реликвии"],
  [/(\d+)m to carrier/gi, "$1м до носителя"],
  [/(\d+)m to lift/gi, "$1м до лифта"],
  [/СДАТЬ \+(\d+) at lift - (\d+)m/gi, "Сдать +$1 у лифта - $2м"],
  [/cashout imminent/gi, "скоро сдаст"],
  [/cashout in (\d+)s/gi, "сдача через $1с"],
  [/intercept with E/gi, "перехватите на E"],
  [/deny Red \+(\d+) \/ swing \+(\d+)/gi, "сорвать Red +$1 / swing +$2"],
  [/(\d+)s left/gi, "$1с осталось"],
  [/(\d+)s to bank/gi, "$1с до сдачи"],
  [/Cashout/gi, "Сдача добычи"],
  [/Escape/gi, "Побег"],
  [/No relics banked/gi, "Реликвии не сданы"],
  [/Clean bonus/gi, "Чистый бонус"],
  [/Loot chain/gi, "Цепочка добычи"],
  [/Final Case File/gi, "Финальное дело"],
  [/Winner/gi, "Победитель"]
];

const zhTextReplacements: Array<[RegExp, string]> = [
  [/Breach Sprint/gi, "突破冲刺"],
  [/Ghost Step/gi, "幽步"],
  [/Afterburner/gi, "后燃"],
  [/STEAL ROUTE/gi, "偷取路线"],
  [/INTERCEPT ROUTE/gi, "拦截路线"],
  [/COMEBACK ROUTE/gi, "反超路线"],
  [/EXIT ROUTE/gi, "撤离路线"],
  [/BREAKOUT RUSH/gi, "突破冲刺"],
  [/VAULT RUSH/gi, "金库冲刺"],
  [/Greed route armed/gi, "贪婪路线已就绪"],
  [/Cashout route armed/gi, "结算路线已就绪"],
  [/Cashout \+(\d+) if you survive/gi, "生还可结算 +$1"],
  [/Bank \+(\d+) at Atrium Lift/gi, "在中庭升降梯存入 +$1"],
  [/Argent Crown marker live/gi, "银冠标记已激活"],
  [/Atrium Lift marker live/gi, "中庭升降梯标记已激活"],
  [/BANK \+(\d+)/gi, "结算 +$1"],
  [/Cashout \+(\d+)/gi, "结算 +$1"],
  [/CASHOUT \+(\d+)/gi, "结算 +$1"],
  [/HIGH VALUE/gi, "高价值"],
  [/RIVAL ENTRY/gi, "对手入口"],
  [/\bEXTRACT\b/gi, "撤离"],
  [/ESCAPE LIFT/gi, "撤离升降梯"],
  [/RISK (\d+)/gi, "风险 $1"],
  [/Risk \+(\d+)/gi, "风险 +$1"],
  [/PRESS G/gi, "按 G"],
  [/STANDBY/gi, "待命"],
  [/\bYOU\b/gi, "你"],
  [/Atrium Lift/gi, "中庭升降梯"],
  [/Inner Vault/gi, "内层金库"],
  [/Vault Door/gi, "金库门"],
  [/Moon Gallery/gi, "月亮展厅"],
  [/Guard Post/gi, "守卫岗"],
  [/Silver Archive/gi, "银档案室"],
  [/Crystal Lift/gi, "水晶升降梯"],
  [/East Hall/gi, "东厅"],
  [/West Hall/gi, "西厅"],
  [/Atrium/gi, "中庭"],
  [/Carrier/gi, "携带者"],
  [/Hunter/gi, "猎手"],
  [/Scanner/gi, "扫描者"],
  [/Raider/gi, "突袭者"],
  [/Marks you/gi, "正在标记你"],
  [/Scan pressure/gi, "扫描压力"],
  [/Raiding ([^\n]+)/gi, "突袭$1"],
  [/Cashout in (\d+)s · (\d+)m/gi, "$1秒后结算 · $2米"],
  [/Waking in (\d+)s · (\d+)m/gi, "$1秒后苏醒 · $2米"],
  [/Scan lock · (\d+)m/gi, "扫描锁定 · $1米"],
  [/On you · (\d+)m/gi, "贴近你 · $1米"],
  [/Closing · (\d+)m/gi, "正在接近 · $1米"],
  [/(\d+)m route/gi, "$1米路线"],
  [/Intercept now/gi, "立即拦截"],
  [/Cut off before lift/gi, "在升降梯前切断"],
  [/Dash or break line/gi, "冲刺或摆脱视线"],
  [/Jam or break line/gi, "干扰或摆脱视线"],
  [/Beat them to loot/gi, "抢先拿到战利品"],
  [/Use the head start/gi, "利用领先时间"],
  [/Moon Vault breach started\./gi, "月库突破开始。"],
  [/Rival agents wait for your first score\./gi, "对手特工正等待你的首次得分。"],
  [/Move fast\. Steal clean\. Escape before lockdown\./gi, "快速移动，干净偷取，在封锁前撤离。"],
  [/Moon Vault Contract/gi, "月库合约"],
  [/Stole Moon Pearl \+ Argent Crown/gi, "偷取月亮珍珠 + 银冠"],
  [/Recovered Moon Pearl from rivals/gi, "从对手处夺回月亮珍珠"],
  [/Comeback cashout beat Red from behind/gi, "反超结算击败 Red"],
  [/Case title:/gi, "档案标题:"],
  [/Escaped with (\d+) loot/gi, "携带 $1 战利品撤离"],
  [/Steal the Moon Pearl/gi, "偷取月亮珍珠"],
  [/Steal Moon Pearl/gi, "偷取月亮珍珠"],
  [/Stole Moon Pearl/gi, "偷取月亮珍珠"],
  [/Stole Argent Crown/gi, "偷取银冠"],
  [/STEAL MOON PEARL/gi, "偷取月亮珍珠"],
  [/Argent Crown/g, "银冠"],
  [/Silver Key/g, "银钥匙"],
  [/Moon Pearl/g, "月亮珍珠"],
  [/First score wins tempo/gi, "先得分掌控节奏"],
  [/Follow the gold marker/gi, "跟随金色标记"],
  [/Follow gold beam/gi, "跟随金色光束"],
  [/The gold marker points to the score\. Rivals arrive fast\./gi, "金色标记指向得分点。对手很快会抵达。"],
  [/Follow the gold beam and steal \+(\d+) before Red wakes up\./gi, "跟随金色光束，在 Red 苏醒前偷取 +$1。"],
  [/First score unlocks the cashout route\./gi, "首次得分会解锁结算路线。"],
  [/Move with WASD \/ ARROWS/gi, "使用 WASD / 方向键移动"],
  [/First hit:/gi, "第一击:"],
  [/First objective/gi, "首要目标"],
  [/Director cue/gi, "导演提示"],
  [/Primary target/gi, "主要目标"],
  [/Vault Stable/gi, "金库稳定"],
  [/Low Profile/gi, "低调潜入"],
  [/Optional risk/gi, "可选风险"],
  [/Cashout window/gi, "结算窗口"],
  [/Steal relic/gi, "偷取遗物"],
  [/STEAL/gi, "偷取"],
  [/Move/gi, "移动"],
  [/Break heat/gi, "摆脱追踪"],
  [/Follow marker/gi, "跟随标记"],
  [/Close gap (\d+)m/gi, "缩短距离 $1米"],
  [/Press E \/ Space to intercept/gi, "按 E / Space 拦截"],
  [/Press E \/ Space to steal/gi, "按 E / Space 偷取"],
  [/Press E \/ Space to jam rival scan/gi, "按 E / Space 干扰扫描"],
  [/Red cashout imminent/gi, "Red 即将结算"],
  [/Intercept ([^ ]+) before lift/gi, "在升降梯前拦截 $1"],
  [/Intercept carrier/gi, "拦截携带者"],
  [/Intercept/gi, "拦截"],
  [/Recover ([^+]+) \+(\d+)/gi, "夺回 $1 +$2"],
  [/Jam the rival scan/gi, "干扰对手扫描"],
  [/Target plotting/gi, "正在规划目标"],
  [/Rivals scanning/gi, "对手正在扫描"],
  [/Rivals wake after first score or (\d+)s/gi, "对手将在首次得分或 $1秒后行动"],
  [/Nearest rival scanning/gi, "正在扫描最近对手"],
  [/Nearest rival ([A-Z]+ \d+m|HERE)/gi, "最近对手 $1"],
  [/Scan clear/gi, "扫描安全"],
  [/S-Rank pace/gi, "S 级节奏"],
  [/Loot race is tied/gi, "战利品竞赛持平"],
  [/Target ([A-Z]+ \d+m|HERE)/gi, "目标 $1"],
  [/Pace unknown/gi, "节奏未知"],
  [/Dash ready/gi, "冲刺就绪"],
  [/Dash cooling/gi, "冲刺冷却中"],
  [/Alibi ready/gi, "托辞脉冲就绪"],
  [/(\d+)m away/gi, "$1米外"],
  [/(\d+)m to relic/gi, "距遗物 $1米"],
  [/(\d+)m to carrier/gi, "距携带者 $1米"],
  [/(\d+)m to lift/gi, "距升降梯 $1米"],
  [/结算 \+(\d+) at lift - (\d+)m/gi, "在升降梯结算 +$1 - $2米"],
  [/cashout imminent/gi, "即将结算"],
  [/cashout in (\d+)s/gi, "$1秒后结算"],
  [/intercept with E/gi, "按 E 拦截"],
  [/deny Red \+(\d+) \/ swing \+(\d+)/gi, "阻止 Red +$1 / 摇摆 +$2"],
  [/(\d+)s left/gi, "剩余 $1秒"],
  [/(\d+)s to bank/gi, "$1秒内结算"],
  [/Cashout/gi, "结算"],
  [/Escape/gi, "撤离"],
  [/No relics banked/gi, "没有结算遗物"],
  [/Clean bonus/gi, "无伤奖励"],
  [/Loot chain/gi, "战利品连锁"],
  [/Final Case File/gi, "最终档案"],
  [/Winner/gi, "胜者"]
];
